import { useNavigate } from 'react-router-dom'
import logoImage from '../images/logo192.png'
import { useState } from 'react'
import { auth, db } from '../services/Firebase'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import { doc, setDoc } from 'firebase/firestore'
import { useTranslation } from 'react-i18next'
import { Bot, Crown, Database, Save, Target } from 'lucide-react'


export default function RegistrationPage() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [fullName, setFullName] = useState('')
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()

    const navigate = useNavigate()

    const handleRegister = async (e) => {
        e.preventDefault();
        setLoading(true)

        if (!fullName) {
            setError(t('fullNameRequired'))
            setLoading(false)
            return;
        }

        if (fullName.length < 5) {
            setError(t('fullNameMinLength'));
            setLoading(false)
            return;
        }
        if (!email) {
            setError(t('emailRequired'));
            setLoading(false)
            return;
        }

        if (!password) {
            setError(t('passwordRequired'));
            setLoading(false)
            return;
        }

        if (password.length < 5) {
            setError(t('passwordMinLength'));
            setLoading(false)
            return;
        }

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user

            await setDoc(doc(db, 'users', user.uid), {
                uid: user.uid,
                fullName: fullName,
                email: user.email,
                createdAt: new Date()
            })
            setLoading(false)
            alert(t('registrationSuccess'))
            navigate('/')
        } catch (err) {
            setError(err.message);
            console.error("Firebase registration error:", err);
            setLoading(error)
        }
    };

    const goToSearchPage = () => {
        navigate('/')
    }

    const goToLoginPage = () => {
        navigate('/login')
    }

    return (
        // <div className='login-page'>
        // {/* <div className="header-container">
        //     <div onClick={() => goToSearchPage()} className='header-left'>
        //         <img src={logoImage} alt="Logo" className="logo" />
        //         <h3>Sigurica AI</h3>
        //     </div>
        // </div> */}

        <div className='login-screen'>
            <div className="header-container-login-registration">
                <div onClick={() => goToSearchPage()} className='header-left-login-registration'>
                    <img src={logoImage} alt="Logo" className="logo" />
                    <h3>Sigurica AI</h3>
                </div>
                <div className='header-right-login-registration'>
                    <p className=''>{t('haveAccount')} <a onClick={() => goToLoginPage()} href=''>{t('registrationPageLogin')}</a></p>
                </div>
            </div>

            <div className='login-left'>
                <form onSubmit={handleRegister} className='login-card'>
                    <h3 className='become-member-title'>{t('becomeMember')}</h3>
                    <div className="form-group">
                        {/* <label for="fname">{t('fullName')}</label> */}
                        <input type="text" placeholder={t('fullName')} id='fname' value={fullName} onChange={(e) => setFullName(e.target.value)} className="form-control" />
                    </div>
                    <div className="form-group">
                        {/* <label for="email">{t('email')}</label> */}
                        <input type="email" id="email" placeholder={t('email')} value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" />
                    </div>
                    <div className="form-group">
                        {/* <label for="pwd">{t('password')}</label> */}
                        <input type="password" id="pwd" placeholder={t('password')} value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" />
                    </div>
                    <button type="submit" className="btn-registration" disabled={loading}>
                        {loading ? (
                            <div className="spinner-border spinner-border-sm-custom" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        ) : (
                            t('join')
                        )}
                    </button>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <div className='privacy-policy-terms-container'>
                        <a className='privacy-policy-terms-item' href="/legal/privacy_policy.html" >{t('privacyPolicy')}</a>|
                        <a className='privacy-policy-terms-item' href="/legal/terms.html" >{t('termsOfUse')}</a>
                    </div>
                </form>
            </div>
            <div className='login-right'>
                <div className='login-privileges'>
                    <h2>{t('membershipBenefitsTitle')}</h2>

                    <div className="benefits-list">
                        <div className="benefits-item">
                            <Bot className="benefit-icon" />
                            <span>{t('membershipBenefits1')}</span>
                        </div>
                        <div className="benefits-item">
                            <Database className="benefit-icon" />
                            <span>{t('membershipBenefits2')}</span>
                        </div>
                        <div className="benefits-item">
                            <Target className="benefit-icon" />
                            <span>{t('membershipBenefits3')}</span>
                        </div>
                        <div className="benefits-item">
                            <Save className="benefit-icon" />
                            <span>{t('membershipBenefits4')}</span>
                        </div>
                        <div className="benefits-item">
                            <Crown className="benefit-icon" />
                            <span>{t('membershipBenefits5')}</span>
                        </div>
                    </div>

                    <p className='membership-benefits-profesional'>{t('membershipBenefits6')}</p>
                </div>
            </div>
        </div >
    )
}
